import type { PlanCode, PlanLimitsDto } from './dtos';

export const PLAN_DISPLAY_NAME_BY_CODE: Record<PlanCode, string> = {
  free: 'Free',
  starter: 'Starter',
  team: 'Team',
};

export const PLAN_DEFAULT_LIMITS_BY_CODE: Record<PlanCode, PlanLimitsDto> = {
  free: {
    userLimit: 1,
    projectLimit: 1,
    executionLimitMonthly: null,
    executionLimitWeekly: 1_000,
    retentionDays: 14,
    orgLimitPerUser: 1,
  },
  starter: {
    userLimit: 2,
    projectLimit: 1,
    executionLimitMonthly: 10_000,
    executionLimitWeekly: null,
    retentionDays: 60,
    orgLimitPerUser: 1,
  },
  team: {
    userLimit: 5,
    projectLimit: 3,
    executionLimitMonthly: 25_000,
    executionLimitWeekly: null,
    retentionDays: 180,
    orgLimitPerUser: 1,
  },
};

export const getPlanDisplayName = (planCode: PlanCode): string =>
  PLAN_DISPLAY_NAME_BY_CODE[planCode];
